import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { GRID_AREA_SUBTITLE } from 'shared/components/Tile/components/Header/constants';

export const Subtitle = styled(Box)(({ theme }) => ({
  gridArea: GRID_AREA_SUBTITLE,
  marginTop: theme.spacing(1),
}));
